import * as mimeTypes from 'constants/mimeTypes';

export const fileSizeLimit = 100 * 1024 * 1024; // 4 MB

export const base64toBlob = (data, type) => {
  const base64WithoutPrefix = data;
  const bytes = atob(base64WithoutPrefix);
  // eslint-disable-next-line prefer-destructuring
  let length = bytes.length;
  // eslint-disable-next-line prefer-const
  let out = new Uint8Array(length);
  // eslint-disable-next-line no-plusplus
  while (length--) {
    out[length] = bytes.charCodeAt(length);
  }
  // eslint-disable-next-line object-shorthand
  return new Blob([out], { type: type });
};

export const blobWithCsv = (data) => {
  return new Blob([data], { type: 'text/csv' });
};

export const getFileDataUri = (base64FileData = '') => {
  if (base64FileData.startsWith('iVBORw0')) return `data:${mimeTypes.PNG};base64,${base64FileData}`;
  if (base64FileData.startsWith('AAA')) return `data:${mimeTypes.MP4};base64,${base64FileData}`;
  if (base64FileData.startsWith('JVBERi0')) return `data:${mimeTypes.PDF};base64,${base64FileData}`;
  return `data:${mimeTypes.JPEG};base64,${base64FileData}`;
};

export const getFileDataUriSvg = (base64FileData = '', mimeType = 'image/svg+xml') => {
  if (
    base64FileData &&
    (base64FileData.startsWith('data:') || base64FileData.startsWith('iVBORw0'))
  ) {
    return base64FileData;
  }
  return `data:${mimeType};base64,${base64FileData}`;
};
